import { getElementRect } from './getElementRect';

export function getRightScrollOffset(container: HTMLElement, scrollOffset: number) {
  const childrenList = Array.from(container.children);
  const containerRect = getElementRect(container);
  const rightBorderPosition = containerRect.width + container.scrollLeft;

  const rightHiddenChild = childrenList.find((child: HTMLElement) => {
    const childRect = getElementRect(child);
    const rightX = childRect.right - containerRect.left;

    return rightX > rightBorderPosition;
  });

  if (!rightHiddenChild) {
    return null;
  }

  const { left } = getElementRect(rightHiddenChild as HTMLElement);

  return left - scrollOffset;
}

export function getLeftScrollOffset(container: HTMLElement, scrollOffset: number) {
  const childrenList = Array.from(container.children);
  const containerRect = getElementRect(container);
  const leftBorderPosition = container.scrollLeft;

  const leftHiddenChildIndex = childrenList.findIndex((child: HTMLElement) => {
    const childRect = getElementRect(child);
    const leftX = childRect.left - containerRect.left;

    return leftX >= leftBorderPosition;
  });

  const leftHiddenChild = leftHiddenChildIndex > 0 ? childrenList[leftHiddenChildIndex - 1] : null;

  if (!leftHiddenChild) {
    return null;
  }

  const { right } = getElementRect(leftHiddenChild as HTMLElement);

  return right - containerRect.width + scrollOffset;
}
